import React, { useState, useEffect } from "react";
import { Typography, TextField, Autocomplete, Box } from "@mui/material";
import ReactSelect from "react-select";
import { useDispatch } from "react-redux";
import { autoCompleteV2, autoCompleteV2Skill, autoCompleteQualifications, autoCompleteQualificationsLevels, autoCompleteLocations } from "../../actions/applicationAssistant_action";
import config from "../../config";
import _ from "lodash";

const sxStyles = {
  nav: {
    width: { xs: 200, sm: 200, md: 230 },
    mt: 0.625,
  },
  application: {
    width: "100%",
    mt: 0.625,
  },
  chat: {
    mt: 1.25,
    backgroundColor: "#f5f5f5",
    borderColor: "#fa6a14",
    borderWidth: 0.5,
  },
};

const OrgChip = ({}) => {
  return (
    <img
      style={{maxHeight:40}}
      src={
        config.STORAGE_CLOUDFRONT_URL + "/logos/qualtest_intervention_logo.png"
      }
    />
  )
}

const CustomAutoComplete = ({
    sx,
    onSelect,
    autoCompleteQuery,
    error,
    disabled,
    occListOptions,
    fontSize = "small",
    size = "small",
    placeholder,
    type,
    fullWidth = false
    }) => {
    const fontSizeNumber = fontSize === "small" ? "0.8125rem" : "1rem"
    const [filteredOptions, setFilteredOptions] = useState(type === "occupation" && occListOptions ? occListOptions.map((item) => {return {label: item, htmlLabel: item, group: "Profile Occupations"}}) : []); 
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchQueue, setSearchQueue] = useState("");

    const onInputChange = async (searchText) => {
      setLoading(searchText)
      setSearchQueue(searchText)
      if(searchText === ""){
        setFilteredOptions(type === "occupation" && occListOptions ? occListOptions.map((item) => {return {label: item, htmlLabel: item, group: "Profile Occupations"}}) : [])
      }
      else{
        const response = await autoCompleteQuery(searchText);
        // console.log(response)
        if(response && (response.directMatches || response.closeMatches)){
          setFilteredOptions([...response.directMatches, ...response.closeMatches])
        }
        else{
          setFilteredOptions([])        
        }
      }
      setLoading(false)
    };

    useEffect(() => {
      async function autoCompleteHandeler() {
        if(!loading){
          if(input !== searchQueue){
            onInputChange(input);
          }
        }
      }
      autoCompleteHandeler()
    }, [input, loading, searchQueue]);
  
    return (
        <Autocomplete
          sx={sx}
          fullWidth={fullWidth}
          disabled={disabled}
          onInputChange={(event, searchText) => setInput(searchText)}
          onChange={(e, v) => {
            if(v){
              onSelect(v.label);
              setInput(v.label);             
            }
          }}
          inputValue={input}
          options={filteredOptions}
          getOptionLabel={(option) => option.label}
          groupBy={(option) => option.group}
          renderInput={(params) => {
            return (
              <TextField 
                {...params}
                size={size}
                InputLabelProps={{...params.InputLabelProps, style: { fontSize:fontSizeNumber}}}
                InputProps={{...params.InputProps, style: { fontSize: fontSizeNumber}}}
                label={placeholder}
                placeholder={placeholder}
                variant="outlined" 
                fullWidth 
                error={error}
              />
            ) 
          }}
          renderOption={(props, option) => (
            <Typography
              {...props}
              key={option.label}
              sx={{width: "100%", fontSize:fontSizeNumber, display:"flex", alignItems:"center", whiteSpace: "pre", display: "flex", justifyContent: "space-between"}} 
            >
              <Box component="span">
                {/* {ReactHtmlParser(option.htmlLabel)} */}
                {option.label}
              </Box>
              {option.orgQual && <OrgChip/>}
            </Typography>
          )}
          filterOptions={(options) => options}
        />
    );
  };

export const EntitiesSearch = ({
    onSelect,
    addOccupationFilter,
    disabled, 
    occList, 
    interalRolesOnly, 
    internalMobilityRoles,
    stylePreset = "nav",
    size="small",
    fontSize="small",
    fullWidth,
    placeholder="",
    type = "occupation",
}) => {
    const dispatch = useDispatch();

    const queryTarget = {
        "occupation": (text) => dispatch(autoCompleteV2(text)),
        "skills": (text) => dispatch(autoCompleteV2Skill(text)),
        "qualifications": (text) => dispatch(autoCompleteQualifications(text)),
        "qualificationLevels": (text) => dispatch(autoCompleteQualificationsLevels(text)),
        "locations": (text) => dispatch(autoCompleteLocations(text))
    };

    if(interalRolesOnly && internalMobilityRoles){
        const options = internalMobilityRoles.map((item) => {return{value:item.ID, label: item.roleName}})
        return (
            <Box sx={sxStyles.nav}>
              <ReactSelect
                  placeholder="What Occupation"
                  onChange={(event) => {
                      if(event.value){
                          const role = internalMobilityRoles.find((item) => item.ID === event.value);
                          addOccupationFilter(role.occupation, false)
                      }
                  }}
                  options={options}
                  menuPortalTarget={document.body}
                  menuPosition={'fixed'}
                  isDisabled={disabled}
                  styles={{ container: (base) => ({ ...base, width: '100%' }) }}
              />
            </Box>
        )
    }
    else if(!interalRolesOnly){
        return (
            <>
                <CustomAutoComplete
                    sx={sxStyles[stylePreset]}
                    type={type}
                    placeholder={placeholder}
                    fontSize={fontSize}
                    size={size}
                    onSelect={(value) => onSelect([value])}
                    occListOptions={occList}
                    error={false}
                    disabled={disabled}
                    autoCompleteQuery={queryTarget[type]}
                    fullWidth={fullWidth}
                />
            </>
        )
    }
    else{
        return <></>
    }
};
